import Action from "../actions"

export function masterDataReducer(state = {
    roles: {
        rows: [],
        total: 0
    },
    occupations: {
        rows: [],
        total: 0
    },
    occDetail: {
        Code: "",
        Id: null,
        IsParent: 1,
        Name: "",
        ParentId: 0,
        SubLevel: 0,
        SubName: "",
    },
    districts: [],
    provinces: []
}, action) {
    if (action.type === Action.SET_MASTER_DATA) {
        return action.data
    }
    return state;
}
